import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import MessageApi from "Services/Message";

const MessageDeleteModal = ({ openDialog, messageId, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (!messageId) {
      dispatch(
        showSnackbar({
          message: "Message ID not found",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));
    MessageApi.deleteMessage(messageId).then(
      () => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: "Message deleted successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose(true);
      },
      (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Error while deleting message",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
      }
    );
  };

  return (
    <Dialog open={openDialog} onClose={() => handleClose(false)} fullWidth maxWidth="xs">
      <DialogTitle>{"Are you sure delete this message ?"}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Message ID: {messageId || "-"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Disagree</Button>
        <Button onClick={handleDelete} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDeleteModal;
